import Valid from "./Valid";
import InValid from "./InValid";
import View from "./View";
import DoctorsIcon from "./DoctorsIcon";
import SearchIcon from "./SearchIcon";
import NotificationIcon from "./NotificationIcon";
import CalendarIcon from './CalendarIcon'
import EditIcon from "./EditIcon";
import PdfIcon from "./PdfIcon";
import VerifyIcon from "./VerifyIcon";
import UnVerifiedIcon from './UnVerifiedIcon'
import BackIcon from "./BackIcon";
import Leads from "./Leads";
import LeaveIcon from "./LeaveIcon";
import Calendar from './Calendar'
import ProjectIcon from "./ProjectIcon";
import WebinarIcon from './WebinarIcon'
import Pdf from "./Pdf";
import WikiIcon from "./WikiIcon";
import Info from "./Info";
export {
    Valid, InValid, View, DoctorsIcon, SearchIcon, NotificationIcon, PdfIcon, CalendarIcon,  EditIcon, VerifyIcon, UnVerifiedIcon, BackIcon, LeaveIcon, Leads, Calendar, ProjectIcon, WebinarIcon, WikiIcon,
    Pdf,
    Info
}